import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
export const initialState = {
  value: [],
  loading: false
};

export const addCareDxDropSite = createAsyncThunk(
  "careDxDropSite/addCareDxDropSite",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.addDropSite(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const addCareDxDropSiteSlice = createSlice({
  name: "addCareDxDropSite",
  initialState,
  reducers: {
    clearAddCareDxDropSiteResponse(state, action) {
      state.value = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCareDxDropSite.pending, (state) => {
        state.loading = true;
      })
      .addCase(addCareDxDropSite.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
        state.days = action.payload.days;
      })
      .addCase(addCareDxDropSite.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const addCareDxDropSiteResponse = (state) => state.addCareDxDropSite.value;
export const {clearAddCareDxDropSiteResponse} = addCareDxDropSiteSlice.actions;
export default addCareDxDropSiteSlice.reducer;
